var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Square_Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Square_Right",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.75V4.25C17.5 2.88281 16.3672 1.75 15 1.75H2.5C1.09375 1.75 0 2.88281 0 4.25V16.75C0 18.1562 1.09375 19.25 2.5 19.25H15C16.3672 19.25 17.5 18.1562 17.5 16.75ZM9.10156 15.4609C8.86719 15.3828 8.75 15.1484 8.75 14.875V12.375H5C4.29688 12.375 3.75 11.8281 3.75 11.125V9.875C3.75 9.21094 4.29688 8.625 5 8.625H8.75V6.125C8.75 5.89062 8.86719 5.65625 9.10156 5.57812C9.33594 5.46094 9.60938 5.53906 9.80469 5.69531L14.1797 10.0703C14.4141 10.3047 14.4141 10.7344 14.1797 10.9688L9.80469 15.3438C9.60938 15.5 9.33594 15.5781 9.10156 15.4609Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRight);
export default ForwardRef;